module.exports = __webpack_public_path__ + "img/icon_map_4_yj_hg_c.5cbd6c74.png";